const collator = new Intl.Collator("en", {numeric: true, sensitivity: "base"});

export const naturalCompare = (a, b) => {
	const byNatural = collator.compare(String(a), String(b));
	if (byNatural !== 0) return byNatural;
	const rawA = String(a);
	const rawB = String(b);
	return rawA < rawB ? -1 : rawA > rawB ? 1 : 0;
};

export const normalizeOption = option => {
	if (option !== null && typeof option === "object") {
		const {value} = option;
		const label = option.label === undefined || option.label === null ? String(value) : String(option.label);
		return {value, label};
	}
	return {value: option, label: String(option)};
};

export const sortOptionsNaturally = options =>
	(options || [])
		.map((option, index) => ({option: normalizeOption(option), index}))
		.sort((a, b) => naturalCompare(a.option.label, b.option.label) || a.index - b.index)
		.map(({option}) => ({...option, matchKey: option.label.toUpperCase()}));


export const rankSortedSuggestions = (sortedOptions, query) => {
	const needle = query === undefined || query === null ? "" : String(query).trim().toUpperCase();
	if (!needle) return sortedOptions;

	const exact = [];
	const prefix = [];
	const contains = [];
	for (const option of sortedOptions) {
		if (option.matchKey === needle) exact.push(option);
		else if (option.matchKey.startsWith(needle)) prefix.push(option);
		else if (option.matchKey.includes(needle)) contains.push(option);
	}
	return exact.concat(prefix, contains);
};

export const rankSuggestions = (options, query) => rankSortedSuggestions(sortOptionsNaturally(options), query);
